import styled from '@emotion/styled';
import { pxToRem } from '@lbcamden/lib-react';

export const ConditionalFormInputRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  width: 100%;
`;

export const RadioButtonContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(3)};
  align-items: center;

  label {
    ${({ theme }) => theme.text.body1};
  }
`;

export const NestedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  padding-left: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  margin-left: ${pxToRem(17)};
  border-left: 5px solid ${({ theme }) => theme.colors.mutedLight};
`;
